/*! howler.js v2.0.0-beta7 | (c) 2013-2016, James Simpson of GoldFire Studios | MIT License | howlerjs.com */ ! function() {
    "use strict";

    function e() {
        try {
            "undefined" != typeof AudioContext ? n = new AudioContext : "undefined" != typeof webkitAudioContext ? n = new webkitAudioContext : o = !1
        } catch (e) {
            o = !1
        }
        if (!o)
            if ("undefined" != typeof Audio) try {
                var d = new Audio;
                "undefined" == typeof d.oncanplaythrough && (u = "canplay")
            } catch (e) {
                t = !0
            } else t = !0;
        try {
            var d = new Audio;
            d.muted && (t = !0)
        } catch (e) {}
        var a = /iP(hone|od|ad)/.test(navigator.platform),
            i = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/),
            _ = i ? parseInt(i[1], 10) : null;
        if (a && _ && 9 > _) {
            var s = /safari/.test(window.navigator.userAgent.toLowerCase());
            (window.navigator.standalone && !s || !window.navigator.standalone && !s) && (o = !1)
        }
        o && (r = "undefined" == typeof n.createGain ? n.createGainNode() : n.createGain(), r.gain.value = 1, r.connect(n.destination))
    }
    var n = null,
        o = !0,
        t = !1,
        r = null,
        u = "canplaythrough";
    e();
    var d = function() {
        this.init()
    };
    d.prototype = {
        init: function() {
            var e = this || a;
            return e._codecs = {}, e._howls = [], e._muted = !1, e._volume = 1, e.state = n ? n.state || "running" : "running", e.autoSuspend = !0, e._autoSuspend(), e.mobileAutoEnable = !0, e.noAudio = t, e.usingWebAudio = o, e.ctx = n, t || e._setupCodecs(), e
        },
        volume: function(e) {
            var n = this || a;
            if (e = parseFloat(e), "undefined" != typeof e && e >= 0 && 1 >= e) {
                n._volume = e, o && (r.gain.value = e);
                for (var t = 0; t < n._howls.length; t++)
                    if (!n._howls[t]._webAudio)
                        for (var u = n._howls[t]._getSoundIds(), d = 0; d < u.length; d++) {
                            var i = n._howls[t]._soundById(u[d]);
                            i && i._node && (i._node.volume = i._volume * e)
                        }
                    return n
            }
            return n._volume
        },
        mute: function(e) {
            var n = this || a;
            n._muted = e, o && (r.gain.value = e ? 0 : n._volume);
            for (var t = 0; t < n._howls.length; t++)
                if (!n._howls[t]._webAudio)
                    for (var u = n._howls[t]._getSoundIds(), d = 0; d < u.length; d++) {
                        var i = n._howls[t]._soundById(u[d]);
                        i && i._node && (i._node.muted = e ? !0 : i._muted)
                    }
                return n
        },
        isMuted: function() {
        	var n = this || a;
        	return n._muted
        },
        unload: function() {
            for (var o = this || a, t = o._howls.length - 1; t >= 0; t--) o._howls[t].unload();
            return o.usingWebAudio && "undefined" != typeof n.close && (o.ctx = null, n.close(), e(), o.ctx = n), o
        },
        codecs: function(e) {
            return (this || a)._codecs[e]
        },
        _setupCodecs: function() {
            var e = this || a,
                n = new Audio,
                o = n.canPlayType("audio/mpeg;").replace(/^no$/, ""),
                t = /OPR\//.test(navigator.userAgent);
            return e._codecs = {
                mp3: !(t || !o && !n.canPlayType("audio/mp3;").replace(/^no$/, "")),
                mpeg: !!o,
                opus: !!n.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!n.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!n.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!n.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ""),
                aac: !!n.canPlayType("audio/aac;").replace(/^no$/, ""),
                m4a: !!(n.canPlayType("audio/x-m4a;") || n.canPlayType("audio/m4a;") || n.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(n.canPlayType("audio/x-mp4;") || n.canPlayType("audio/mp4;") || n.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!n.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ""),
                webm: !!n.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ""),
                dolby: !!n.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, "")
            }, e
        },
        _enableMobileAudio: function() {
            var e = this || a,
                o = /iPhone|iPad|iPod|Android|BlackBerry|BB10|Silk/i.test(navigator.userAgent),
                t = !!("ontouchend" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
            if (!n || !e._mobileEnabled && o && t) {
                e._mobileEnabled = !1;
                var r = function() {
                    var o = n.createBuffer(1, 1, 22050),
                        t = n.createBufferSource();
                    t.buffer = o, t.connect(n.destination), "undefined" == typeof t.start ? t.start(0) : t.start(0), t.onended = function() {
                        t.disconnect(0), e._mobileEnabled = !0, e.mobileAutoEnable = !1, document.removeEventListener("touchend", r, !0)
                    }
                };
                return document.addEventListener("touchend", r, !0), e
            }
        },
        _autoSuspend: function() {
            var e = this;
            if (e.autoSuspend && n && "undefined" != typeof n.suspend && o) {
                for (var t = 0; t < e._howls.length; t++)
                    if (e._howls[t]._webAudio)
                        for (var r = 0; r < e._howls[t]._sounds.length; r++)
                            if (!e._howls[t]._sounds[r]._paused) return e;
                return e._suspendTimer = setTimeout(function() {
                    e.autoSuspend && (e._suspendTimer = null, e.state = "suspending", n.suspend().then(function() {
                        e.state = "suspended", e._resumeAfterSuspend && (delete e._resumeAfterSuspend, e._autoResume())
                    }))
                }, 3e4), e
            }
        },
        _autoResume: function() {
            var e = this;
            if (n && "undefined" != typeof n.resume && o) return "running" === e.state && e._suspendTimer ? (clearTimeout(e._suspendTimer), e._suspendTimer = null) : "suspended" === e.state ? (e.state = "resuming", n.resume().then(function() {
                e.state = "running"
            }), e._suspendTimer && (clearTimeout(e._suspendTimer), e._suspendTimer = null)) : "suspending" === e.state && (e._resumeAfterSuspend = !0), e
        }
    };
    var a = new d,
        i = function(e) {
            var n = this;
            return e.src && 0 !== e.src.length ? void n.init(e) : void console.error("An array of source files must be passed with any new Howl.")
        };
    i.prototype = {
        init: function(e) {
            var t = this;
            return t._autoplay = e.autoplay || !1, t._format = "string" != typeof e.format ? e.format : [e.format], t._html5 = e.html5 || !1, t._muted = e.mute || !1, t._loop = e.loop || !1, t._pool = e.pool || 5, t._preload = "boolean" == typeof e.preload ? e.preload : !0, t._rate = e.rate || 1, t._sprite = e.sprite || {}, t._src = "string" != typeof e.src ? e.src : [e.src], t._volume = void 0 !== e.volume ? e.volume : 1, t._duration = 0, t._loaded = !1, t._sounds = [], t._endTimers = {}, t._queue = [], t._onend = e.onend ? [{
                fn: e.onend
            }] : [], t._onfade = e.onfade ? [{
                fn: e.onfade
            }] : [], t._onload = e.onload ? [{
                fn: e.onload
            }] : [], t._onloaderror = e.onloaderror ? [{
                fn: e.onloaderror
            }] : [], t._onpause = e.onpause ? [{
                fn: e.onpause
            }] : [], t._onplay = e.onplay ? [{
                fn: e.onplay
            }] : [], t._onstop = e.onstop ? [{
                fn: e.onstop
            }] : [], t._onmute = e.onmute ? [{
                fn: e.onmute
            }] : [], t._onvolume = e.onvolume ? [{
                fn: e.onvolume
            }] : [], t._onrate = e.onrate ? [{
                fn: e.onrate
            }] : [], t._onseek = e.onseek ? [{
                fn: e.onseek
            }] : [], t._webAudio = o && !t._html5, "undefined" != typeof n && n && a.mobileAutoEnable && a._enableMobileAudio(), a._howls.push(t), t._preload && t.load(), t
        },
        load: function() {
            var e = this,
                n = null;
            if (t) return void e._emit("loaderror", null, "No audio support.");
            "string" == typeof e._src && (e._src = [e._src]);
            for (var o = 0; o < e._src.length; o++) {
                var r, u;
                if (e._format && e._format[o] ? r = e._format[o] : (u = e._src[o], r = /^data:audio\/([^;,]+);/i.exec(u), r || (r = /\.([^.]+)$/.exec(u.split("?", 1)[0])), r && (r = r[1].toLowerCase())), a.codecs(r)) {
                    n = e._src[o];
                    break
                }
            }
            return n ? (e._src = n, "https:" === window.location.protocol && "http:" === n.slice(0, 5) && (e._html5 = !0, e._webAudio = !1), new _(e), e._webAudio && l(e), e) : void e._emit("loaderror", null, "No codec support for selected audio sources.")
        },
        play: function(e) {
            var o = this,
                t = arguments,
                r = null;
            if ("number" == typeof e) r = e, e = null;
            else if ("undefined" == typeof e) {
                e = "__default";
                for (var d = 0, i = 0; i < o._sounds.length; i++) o._sounds[i]._paused && !o._sounds[i]._ended && (d++, r = o._sounds[i]._id);
                1 === d ? e = null : r = null
            }
            var _ = r ? o._soundById(r) : o._inactiveSound();
            if (!_) return null;
            if (r && !e && (e = _._sprite || "__default"), !o._loaded && !o._sprite[e]) return o._queue.push({
                event: "play",
                action: function() {
                    o.play(o._soundById(_._id) ? _._id : void 0)
                }
            }), _._id;
            if (r && !_._paused) return _._id;
            o._webAudio && a._autoResume();
            var s = _._seek > 0 ? _._seek : o._sprite[e][0] / 1e3,
                l = (o._sprite[e][0] + o._sprite[e][1]) / 1e3 - s,
                f = 1e3 * l / Math.abs(_._rate);
            f !== 1 / 0 && (o._endTimers[_._id] = setTimeout(o._ended.bind(o, _), f)), _._paused = !1, _._ended = !1, _._sprite = e, _._seek = s, _._start = o._sprite[e][0] / 1e3, _._stop = (o._sprite[e][0] + o._sprite[e][1]) / 1e3, _._loop = !(!_._loop && !o._sprite[e][2]);
            var c = _._node;
            if (o._webAudio) {
                var p = function() {
                    o._refreshBuffer(_);
                    var e = _._muted || o._muted ? 0 : _._volume * a.volume();
                    c.gain.setValueAtTime(e, n.currentTime), _._playStart = n.currentTime, "undefined" == typeof c.bufferSource.start ? _._loop ? c.bufferSource.noteGrainOn(0, s, 86400) : c.bufferSource.noteGrainOn(0, s, l) : _._loop ? c.bufferSource.start(0, s, 86400) : c.bufferSource.start(0, s, l), o._endTimers[_._id] || f === 1 / 0 || (o._endTimers[_._id] = setTimeout(o._ended.bind(o, _), f)), t[1] || setTimeout(function() {
                        o._emit("play", _._id)
                    }, 0)
                };
                o._loaded ? p() : (o.once("load", p, _._id), o._clearTimer(_._id))
            } else {
                var m = function() {
                    c.currentTime = s, c.muted = _._muted || o._muted || a._muted || c.muted, c.volume = _._volume * a.volume(), c.playbackRate = _._rate, setTimeout(function() {
                        c.play(), t[1] || o._emit("play", _._id)
                    }, 0)
                };
                if (4 === c.readyState || !c.readyState && navigator.isCocoonJS) m();
                else {
                    var v = function() {
                        f !== 1 / 0 && (o._endTimers[_._id] = setTimeout(o._ended.bind(o, _), f)), m(), c.removeEventListener(u, v, !1)
                    };
                    c.addEventListener(u, v, !1), o._clearTimer(_._id)
                }
            }
            return _._id
        },
        pause: function(e) {
            var n = this;
            if (!n._loaded) return n._queue.push({
                event: "pause",
                action: function() {
                    n.pause(e)
                }
            }), n;
            for (var o = n._getSoundIds(e), t = 0; t < o.length; t++) {
                n._clearTimer(o[t]);
                var r = n._soundById(o[t]);
                if (r && !r._paused) {
                    if (r._seek = n.seek(o[t]), r._paused = !0, n._stopFade(o[t]), r._node)
                        if (n._webAudio) {
                            if (!r._node.bufferSource) return n;
                            "undefined" == typeof r._node.bufferSource.stop ? r._node.bufferSource.noteOff(0) : r._node.bufferSource.stop(0), r._node.bufferSource = null
                        } else isNaN(r._node.duration) && r._node.duration !== 1 / 0 || r._node.pause();
                    arguments[1] || n._emit("pause", r._id)
                }
            }
            return n
        },
        stop: function(e) {
            var n = this;
            if (!n._loaded) return "undefined" != typeof n._sounds[0]._sprite && n._queue.push({
                event: "stop",
                action: function() {
                    n.stop(e)
                }
            }), n;
            for (var o = n._getSoundIds(e), t = 0; t < o.length; t++) {
                n._clearTimer(o[t]);
                var r = n._soundById(o[t]);
                if (r && !r._paused) {
                    if (r._seek = r._start || 0, r._paused = !0, r._ended = !0, n._stopFade(o[t]), r._node)
                        if (n._webAudio) {
                            if (!r._node.bufferSource) return n;
                            "undefined" == typeof r._node.bufferSource.stop ? r._node.bufferSource.noteOff(0) : r._node.bufferSource.stop(0), r._node.bufferSource = null
                        } else isNaN(r._node.duration) && r._node.duration !== 1 / 0 || (r._node.pause(), r._node.currentTime = r._start || 0);
                    n._emit("stop", r._id)
                }
            }
            return n
        },
        mute: function(e, o) {
            var t = this;
            if (!t._loaded) return t._queue.push({
                event: "mute",
                action: function() {
                    t.mute(e, o)
                }
            }), t;
            if ("undefined" == typeof o) {
                if ("boolean" != typeof e) return t._muted;
                t._muted = e
            }
            for (var r = t._getSoundIds(o), u = 0; u < r.length; u++) {
                var d = t._soundById(r[u]);
                d && (d._muted = e, t._webAudio && d._node ? d._node.gain.setValueAtTime(e ? 0 : d._volume * a.volume(), n.currentTime) : d._node && (d._node.muted = a._muted ? !0 : e), t._emit("mute", d._id))
            }
            return t
        },
        volume: function() {
            var e, o, t = this,
                r = arguments;
            if (0 === r.length) return t._volume;
            if (1 === r.length) {
                var u = t._getSoundIds(),
                    d = u.indexOf(r[0]);
                d >= 0 ? o = parseInt(r[0], 10) : e = parseFloat(r[0])
            } else r.length >= 2 && (e = parseFloat(r[0]), o = parseInt(r[1], 10));
            var i;
            if (!("undefined" != typeof e && e >= 0 && 1 >= e)) return i = o ? t._soundById(o) : t._sounds[0], i ? i._volume : 0;
            if (!t._loaded) return t._queue.push({
                event: "volume",
                action: function() {
                    t.volume.apply(t, r)
                }
            }), t;
            "undefined" == typeof o && (t._volume = e), o = t._getSoundIds(o);
            for (var _ = 0; _ < o.length; _++) i = t._soundById(o[_]), i && (i._volume = e, r[2] || t._stopFade(o[_]), t._webAudio && i._node && !i._muted ? i._node.gain.setValueAtTime(e * a.volume(), n.currentTime) : i._node && !i._muted && (i._node.volume = e * a.volume()), t._emit("volume", i._id));
            return t
        },
        fade: function(e, o, t, r) {
            var u = this;
            if (!u._loaded) return u._queue.push({
                event: "fade",
                action: function() {
                    u.fade(e, o, t, r)
                }
            }), u;
            u.volume(e, r);
            for (var d = u._getSoundIds(r), a = 0; a < d.length; a++) {
                var i = u._soundById(d[a]);
                if (i)
                    if (r || u._stopFade(d[a]), u._webAudio && !i._muted) {
                        var _ = n.currentTime,
                            s = _ + t / 1e3;
                        i._volume = e, i._node.gain.setValueAtTime(e, _), i._node.gain.linearRampToValueAtTime(o, s), i._timeout = setTimeout(function(e, t) {
                            delete t._timeout, setTimeout(function() {
                                t._volume = o, u._emit("fade", e)
                            }, s - n.currentTime > 0 ? Math.ceil(1e3 * (s - n.currentTime)) : 0)
                        }.bind(u, d[a], i), t)
                    } else {
                        var l = Math.abs(e - o),
                            f = e > o ? "out" : "in",
                            c = l / .01,
                            p = t / c;
                        ! function() {
                            var n = e;
                            i._interval = setInterval(function(e, t) {
                                n += "in" === f ? .01 : -.01, n = Math.max(0, n), n = Math.min(1, n), n = Math.round(100 * n) / 100, u.volume(n, e, !0), n === o && (clearInterval(t._interval), delete t._interval, u._emit("fade", e))
                            }.bind(u, d[a], i), p)
                        }()
                    }
            }
            return u
        },
        _stopFade: function(e) {
            var o = this,
                t = o._soundById(e);
            return t._interval ? (clearInterval(t._interval), delete t._interval, o._emit("fade", e)) : t._timeout && (clearTimeout(t._timeout), delete t._timeout, t._node.gain.cancelScheduledValues(n.currentTime), o._emit("fade", e)), o
        },
        loop: function() {
            var e, n, o, t = this,
                r = arguments;
            if (0 === r.length) return t._loop;
            if (1 === r.length) {
                if ("boolean" != typeof r[0]) return o = t._soundById(parseInt(r[0], 10)), o ? o._loop : !1;
                e = r[0], t._loop = e
            } else 2 === r.length && (e = r[0], n = parseInt(r[1], 10));
            for (var u = t._getSoundIds(n), d = 0; d < u.length; d++) o = t._soundById(u[d]), o && (o._loop = e, t._webAudio && o._node && o._node.bufferSource && (o._node.bufferSource.loop = e));
            return t
        },
        rate: function() {
            var e, n, o = this,
                t = arguments;
            if (0 === t.length) n = o._sounds[0]._id;
            else if (1 === t.length) {
                var r = o._getSoundIds(),
                    u = r.indexOf(t[0]);
                u >= 0 ? n = parseInt(t[0], 10) : e = parseFloat(t[0])
            } else 2 === t.length && (e = parseFloat(t[0]), n = parseInt(t[1], 10));
            var d;
            if ("number" != typeof e) return d = o._soundById(n), d ? d._rate : o._rate;
            if (!o._loaded) return o._queue.push({
                event: "rate",
                action: function() {
                    o.rate.apply(o, t)
                }
            }), o;
            "undefined" == typeof n && (o._rate = e), n = o._getSoundIds(n);
            for (var a = 0; a < n.length; a++)
                if (d = o._soundById(n[a])) {
                    d._rate = e, o._webAudio && d._node && d._node.bufferSource ? d._node.bufferSource.playbackRate.value = e : d._node && (d._node.playbackRate = e);
                    var i = o.seek(n[a]),
                        _ = (o._sprite[d._sprite][0] + o._sprite[d._sprite][1]) / 1e3 - i,
                        s = 1e3 * _ / Math.abs(d._rate);
                    o._clearTimer(n[a]), o._endTimers[n[a]] = setTimeout(o._ended.bind(o, d), s), o._emit("rate", d._id)
                }
            return o
        },
        seek: function() {
            var e, o, t = this,
                r = arguments;
            if (0 === r.length) o = t._sounds[0]._id;
            else if (1 === r.length) {
                var u = t._getSoundIds(),
                    d = u.indexOf(r[0]);
                d >= 0 ? o = parseInt(r[0], 10) : (o = t._sounds[0]._id, e = parseFloat(r[0]))
            } else 2 === r.length && (e = parseFloat(r[0]), o = parseInt(r[1], 10));
            if ("undefined" == typeof o) return t;
            if (!t._loaded) return t._queue.push({
                event: "seek",
                action: function() {
                    t.seek.apply(t, r)
                }
            }), t;
            var a = t._soundById(o);
            if (a) {
                if (!(e >= 0)) return t._webAudio ? a._seek + (t.playing(o) ? n.currentTime - a._playStart : 0) : a._node.currentTime;
                var i = t.playing(o);
                i && t.pause(o, !0), a._seek = e, t._clearTimer(o), i && t.play(o, !0), t._emit("seek", o)
            }
            return t
        },
        playing: function(e) {
            var n = this,
                o = n._soundById(e) || n._sounds[0];
            return o ? !o._paused : !1
        },
        duration: function() {
            return this._duration
        },
        unload: function() {
            for (var e = this, n = e._sounds, o = 0; o < n.length; o++) {
                n[o]._paused || (e.stop(n[o]._id), e._emit("end", n[o]._id)), e._webAudio || (n[o]._node.src = "", n[o]._node.removeEventListener("error", n[o]._errorFn, !1), n[o]._node.removeEventListener(u, n[o]._loadFn, !1)), delete n[o]._node, e._clearTimer(n[o]._id);
                var t = a._howls.indexOf(e);
                t >= 0 && a._howls.splice(t, 1)
            }
            return s && delete s[e._src], e._sounds = [], e = null, null
        },
        on: function(e, n, o, t) {
            var r = this,
                u = r["_on" + e];
            return "function" == typeof n && u.push(t ? {
                id: o,
                fn: n,
                once: t
            } : {
                id: o,
                fn: n
            }), r
        },
        off: function(e, n, o) {
            var t = this,
                r = t["_on" + e];
            if (n) {
                for (var u = 0; u < r.length; u++)
                    if (n === r[u].fn && o === r[u].id) {
                        r.splice(u, 1);
                        break
                    }
            } else if (e) t["_on" + e] = [];
            else
                for (var d = Object.keys(t), u = 0; u < d.length; u++) 0 === d[u].indexOf("_on") && Array.isArray(t[d[u]]) && (t[d[u]] = []);
            return t
        },
        once: function(e, n, o) {
            var t = this;
            return t.on(e, n, o, 1), t
        },
        _emit: function(e, n, o) {
            for (var t = this, r = t["_on" + e], u = r.length - 1; u >= 0; u--) r[u].id && r[u].id !== n && "load" !== e || (setTimeout(function(e) {
                e.call(this, n, o)
            }.bind(t, r[u].fn), 0), r[u].once && t.off(e, r[u].fn, r[u].id));
            return t
        },
        _loadQueue: function() {
            var e = this;
            if (e._queue.length > 0) {
                var n = e._queue[0];
                e.once(n.event, function() {
                    e._queue.shift(), e._loadQueue()
                }), n.action()
            }
            return e
        },
        _ended: function(e) {
            var o = this,
                t = e._sprite,
                r = !(!e._loop && !o._sprite[t][2]);
            if (o._emit("end", e._id), !o._webAudio && r && o.stop(e._id).play(e._id), o._webAudio && r) {
                o._emit("play", e._id), e._seek = e._start || 0, e._playStart = n.currentTime;
                var u = 1e3 * (e._stop - e._start) / Math.abs(e._rate);
                o._endTimers[e._id] = setTimeout(o._ended.bind(o, e), u)
            }
            return o._webAudio && !r && (e._paused = !0, e._ended = !0, e._seek = e._start || 0, o._clearTimer(e._id), e._node.bufferSource = null, a._autoSuspend()), o._webAudio || r || o.stop(e._id), o
        },
        _clearTimer: function(e) {
            var n = this;
            return n._endTimers[e] && (clearTimeout(n._endTimers[e]), delete n._endTimers[e]), n
        },
        _soundById: function(e) {
            for (var n = this, o = 0; o < n._sounds.length; o++)
                if (e === n._sounds[o]._id) return n._sounds[o];
            return null
        },
        _inactiveSound: function() {
            var e = this;
            e._drain();
            for (var n = 0; n < e._sounds.length; n++)
                if (e._sounds[n]._ended) return e._sounds[n].reset();
            return new _(e)
        },
        _drain: function() {
            var e = this,
                n = e._pool,
                o = 0,
                t = 0;
            if (!(e._sounds.length < n)) {
                for (t = 0; t < e._sounds.length; t++) e._sounds[t]._ended && o++;
                for (t = e._sounds.length - 1; t >= 0; t--) {
                    if (n >= o) return;
                    e._sounds[t]._ended && (e._webAudio && e._sounds[t]._node && e._sounds[t]._node.disconnect(0), e._sounds.splice(t, 1), o--)
                }
            }
        },
        _getSoundIds: function(e) {
            var n = this;
            if ("undefined" == typeof e) {
                for (var o = [], t = 0; t < n._sounds.length; t++) o.push(n._sounds[t]._id);
                return o
            }
            return [e]
        },
        _refreshBuffer: function(e) {
            var o = this;
            return e._node.bufferSource = n.createBufferSource(), e._node.bufferSource.buffer = s[o._src], e._node.bufferSource.connect(e._panner ? e._panner : e._node), e._node.bufferSource.loop = e._loop, e._loop && (e._node.bufferSource.loopStart = e._start || 0, e._node.bufferSource.loopEnd = e._stop), e._node.bufferSource.playbackRate.value = o._rate, o
        }
    };
    var _ = function(e) {
        this._parent = e, this.init()
    };
    if (_.prototype = {
            init: function() {
                var e = this,
                    n = e._parent;
                return e._muted = n._muted, e._loop = n._loop, e._volume = n._volume, e._muted = n._muted, e._rate = n._rate, e._seek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = Math.round(Date.now() * Math.random()), n._sounds.push(e), e.create(), e
            },
            create: function() {
                var e = this,
                    o = e._parent,
                    t = a._muted || e._muted || e._parent._muted ? 0 : e._volume * a.volume();
                return o._webAudio ? (e._node = "undefined" == typeof n.createGain ? n.createGainNode() : n.createGain(), e._node.gain.setValueAtTime(t, n.currentTime), e._node.paused = !0, e._node.connect(r)) : (e._node = new Audio, e._errorFn = e._errorListener.bind(e), e._node.addEventListener("error", e._errorFn, !1), e._loadFn = e._loadListener.bind(e), e._node.addEventListener(u, e._loadFn, !1), e._node.src = o._src, e._node.preload = "auto", e._node.volume = t, e._node.load()), e
            },
            reset: function() {
                var e = this,
                    n = e._parent;
                return e._muted = n._muted, e._loop = n._loop, e._volume = n._volume, e._muted = n._muted, e._rate = n._rate, e._seek = 0, e._paused = !0, e._ended = !0, e._sprite = "__default", e._id = Math.round(Date.now() * Math.random()), e
            },
            _errorListener: function() {
                var e = this;
                e._node.error && 4 === e._node.error.code && (a.noAudio = !0), e._parent._emit("loaderror", e._id, e._node.error ? e._node.error.code : 0), e._node.removeEventListener("error", e._errorListener, !1)
            },
            _loadListener: function() {
                var e = this,
                    n = e._parent;
                n._duration = Math.ceil(10 * e._node.duration) / 10, 0 === Object.keys(n._sprite).length && (n._sprite = {
                    __default: [0, 1e3 * n._duration]
                }), n._loaded || (n._loaded = !0, n._emit("load"), n._loadQueue()), n._autoplay && n.play(), e._node.removeEventListener(u, e._loadFn, !1)
            }
        }, o) var s = {},
        l = function(e) {
            var n = e._src;
            if (s[n]) return e._duration = s[n].duration, void p(e);
            if (/^data:[^;]+;base64,/.test(n)) {
                window.atob = window.atob || function(e) {
                    for (var n, o, t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", r = String(e).replace(/=+$/, ""), u = 0, d = 0, a = ""; o = r.charAt(d++); ~o && (n = u % 4 ? 64 * n + o : o, u++ % 4) ? a += String.fromCharCode(255 & n >> (-2 * u & 6)) : 0) o = t.indexOf(o);
                    return a
                };
                for (var o = atob(n.split(",")[1]), t = new Uint8Array(o.length), r = 0; r < o.length; ++r) t[r] = o.charCodeAt(r);
                c(t.buffer, e)
            } else {
                var u = new XMLHttpRequest;
                u.open("GET", n, !0), u.responseType = "arraybuffer", u.onload = function() {
                    c(u.response, e)
                }, u.onerror = function() {
                    e._webAudio && (e._html5 = !0, e._webAudio = !1, e._sounds = [], delete s[n], e.load())
                }, f(u)
            }
        },
        f = function(e) {
            try {
                e.send()
            } catch (n) {
                e.onerror()
            }
        },
        c = function(e, o) {
            n.decodeAudioData(e, function(e) {
                e && o._sounds.length > 0 && (s[o._src] = e, p(o, e))
            }, function() {
                o._emit("loaderror", null, "Decoding audio data failed.")
            })
        },
        p = function(e, n) {
            n && !e._duration && (e._duration = n.duration), 0 === Object.keys(e._sprite).length && (e._sprite = {
                __default: [0, 1e3 * e._duration]
            }), e._loaded || (e._loaded = !0, e._emit("load"), e._loadQueue()), e._autoplay && e.play()
        };
    "function" == typeof define && define.amd && define([], function() {
        return {
            Howler: a,
            Howl: i
        }
    }), "undefined" != typeof exports && (exports.Howler = a, exports.Howl = i), "undefined" != typeof window ? (window.HowlerGlobal = d, window.Howler = a, window.Howl = i, window.Sound = _) : "undefined" != typeof global && (global.HowlerGlobal = d, global.Howler = a, global.Howl = i, global.Sound = _)
}();
/*! Effects Plugin */
! function() {
    "use strict";
    HowlerGlobal.prototype._pos = [0, 0, 0], HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0], HowlerGlobal.prototype._velocity = [0, 0, 0], HowlerGlobal.prototype._listenerAttr = {
        dopplerFactor: 1,
        speedOfSound: 343.3
    }, HowlerGlobal.prototype.pos = function(e, n, t) {
        var o = this;
        return o.ctx && o.ctx.listener ? (n = "number" != typeof n ? o._pos[1] : n, t = "number" != typeof t ? o._pos[2] : t, "number" != typeof e ? o._pos : (o._pos = [e, n, t], o.ctx.listener.setPosition(o._pos[0], o._pos[1], o._pos[2]), o)) : o
    }, HowlerGlobal.prototype.orientation = function(e, n, t, o, r, i) {
        var a = this;
        if (!a.ctx || !a.ctx.listener) return a;
        var p = a._orientation;
        return n = "number" != typeof n ? p[1] : n, t = "number" != typeof t ? p[2] : t, o = "number" != typeof o ? p[3] : o, r = "number" != typeof r ? p[4] : r, i = "number" != typeof i ? p[5] : i, "number" != typeof e ? p : (a._orientation = [e, n, t, o, r, i], a.ctx.listener.setOrientation(e, n, t, o, r, i), a)
    }, HowlerGlobal.prototype.velocity = function(e, n, t) {
        var o = this;
        return o.ctx && o.ctx.listener ? (n = "number" != typeof n ? o._velocity[1] : n, t = "number" != typeof t ? o._velocity[2] : t, "number" != typeof e ? o._velocity : (o._velocity = [e, n, t], o.ctx.listener.setVelocity(o._velocity[0], o._velocity[1], o._velocity[2]), o)) : o
    }, HowlerGlobal.prototype.listenerAttr = function(e) {
        var n = this;
        if (!n.ctx || !n.ctx.listener) return n;
        var t = n._listenerAttr;
        return e ? (n._listenerAttr = {
            dopplerFactor: "undefined" != typeof e.dopplerFactor ? e.dopplerFactor : t.dopplerFactor,
            speedOfSound: "undefined" != typeof e.speedOfSound ? e.speedOfSound : t.speedOfSound
        }, n.ctx.listener.dopplerFactor = t.dopplerFactor, n.ctx.listener.speedOfSound = t.speedOfSound, n) : t
    }, Howl.prototype.init = function(e) {
        return function(n) {
            var t = this;
            return t._orientation = n.orientation || [1, 0, 0], t._pos = n.pos || null, t._velocity = n.velocity || [0, 0, 0], t._pannerAttr = {
                coneInnerAngle: "undefined" != typeof n.coneInnerAngle ? n.coneInnerAngle : 360,
                coneOuterAngle: "undefined" != typeof n.coneOuterAngle ? n.coneOuterAngle : 360,
                coneOuterGain: "undefined" != typeof n.coneOuterGain ? n.coneOuterGain : 0,
                distanceModel: "undefined" != typeof n.distanceModel ? n.distanceModel : "inverse",
                maxDistance: "undefined" != typeof n.maxDistance ? n.maxDistance : 1e4,
                panningModel: "undefined" != typeof n.panningModel ? n.panningModel : "HRTF",
                refDistance: "undefined" != typeof n.refDistance ? n.refDistance : 1,
                rolloffFactor: "undefined" != typeof n.rolloffFactor ? n.rolloffFactor : 1
            }, e.call(this, n)
        }
    }(Howl.prototype.init), Howl.prototype.pos = function(n, t, o, r) {
        var i = this;
        if (!i._webAudio) return i;
        if (!i._loaded) return i.once("play", function() {
            i.pos(n, t, o, r)
        }), i;
        if (t = "number" != typeof t ? 0 : t, o = "number" != typeof o ? -.5 : o, "undefined" == typeof r) {
            if ("number" != typeof n) return i._pos;
            i._pos = [n, t, o]
        }
        for (var a = i._getSoundIds(r), p = 0; p < a.length; p++) {
            var l = i._soundById(a[p]);
            if (l) {
                if ("number" != typeof n) return l._pos;
                l._pos = [n, t, o], l._node && (l._panner || e(l), l._panner.setPosition(n, t, o))
            }
        }
        return i
    }, Howl.prototype.orientation = function(n, t, o, r) {
        var i = this;
        if (!i._webAudio) return i;
        if (!i._loaded) return i.once("play", function() {
            i.orientation(n, t, o, r)
        }), i;
        if (t = "number" != typeof t ? i._orientation[1] : t, o = "number" != typeof o ? i._orientation[2] : o, "undefined" == typeof r) {
            if ("number" != typeof n) return i._orientation;
            i._orientation = [n, t, o]
        }
        for (var a = i._getSoundIds(r), p = 0; p < a.length; p++) {
            var l = i._soundById(a[p]);
            if (l) {
                if ("number" != typeof n) return l._orientation;
                l._orientation = [n, t, o], l._node && (l._panner || e(l), l._panner.setOrientation(n, t, o))
            }
        }
        return i
    }, Howl.prototype.velocity = function(n, t, o, r) {
        var i = this;
        if (!i._webAudio) return i;
        if (!i._loaded) return i.once("play", function() {
            i.velocity(n, t, o, r)
        }), i;
        if (t = "number" != typeof t ? i._velocity[1] : t, o = "number" != typeof o ? i._velocity[2] : o, "undefined" == typeof r) {
            if ("number" != typeof n) return i._velocity;
            i._velocity = [n, t, o]
        }
        for (var a = i._getSoundIds(r), p = 0; p < a.length; p++) {
            var l = i._soundById(a[p]);
            if (l) {
                if ("number" != typeof n) return l._velocity;
                l._velocity = [n, t, o], l._node && (l._panner || e(l), l._panner.setVelocity(n, t, o))
            }
        }
        return i
    }, Howl.prototype.pannerAttr = function() {
        var n, t, o, r = this,
            i = arguments;
        if (!r._webAudio) return r;
        if (0 === i.length) return r._pannerAttr;
        if (1 === i.length) {
            if ("object" != typeof i[0]) return o = r._soundById(parseInt(i[0], 10)), o ? o._pannerAttr : r._pannerAttr;
            n = i[0], "undefined" == typeof t && (r._pannerAttr = {
                coneInnerAngle: "undefined" != typeof n.coneInnerAngle ? n.coneInnerAngle : r._coneInnerAngle,
                coneOuterAngle: "undefined" != typeof n.coneOuterAngle ? n.coneOuterAngle : r._coneOuterAngle,
                coneOuterGain: "undefined" != typeof n.coneOuterGain ? n.coneOuterGain : r._coneOuterGain,
                distanceModel: "undefined" != typeof n.distanceModel ? n.distanceModel : r._distanceModel,
                maxDistance: "undefined" != typeof n.maxDistance ? n.maxDistance : r._maxDistance,
                panningModel: "undefined" != typeof n.panningModel ? n.panningModel : r._panningModel,
                refDistance: "undefined" != typeof n.refDistance ? n.refDistance : r._refDistance,
                rolloffFactor: "undefined" != typeof n.rolloffFactor ? n.rolloffFactor : r._rolloffFactor
            })
        } else 2 === i.length && (n = i[0], t = parseInt(i[1], 10));
        for (var a = r._getSoundIds(t), p = 0; p < a.length; p++)
            if (o = r._soundById(a[p])) {
                var l = o._pannerAttr;
                l = {
                    coneInnerAngle: "undefined" != typeof n.coneInnerAngle ? n.coneInnerAngle : l.coneInnerAngle,
                    coneOuterAngle: "undefined" != typeof n.coneOuterAngle ? n.coneOuterAngle : l.coneOuterAngle,
                    coneOuterGain: "undefined" != typeof n.coneOuterGain ? n.coneOuterGain : l.coneOuterGain,
                    distanceModel: "undefined" != typeof n.distanceModel ? n.distanceModel : l.distanceModel,
                    maxDistance: "undefined" != typeof n.maxDistance ? n.maxDistance : l.maxDistance,
                    panningModel: "undefined" != typeof n.panningModel ? n.panningModel : l.panningModel,
                    refDistance: "undefined" != typeof n.refDistance ? n.refDistance : l.refDistance,
                    rolloffFactor: "undefined" != typeof n.rolloffFactor ? n.rolloffFactor : l.rolloffFactor
                };
                var c = o._panner;
                c ? (c.coneInnerAngle = l.coneInnerAngle, c.coneOuterAngle = l.coneOuterAngle, c.coneOuterGain = l.coneOuterGain, c.distanceModel = l.distanceModel, c.maxDistance = l.maxDistance, c.panningModel = l.panningModel, c.refDistance = l.refDistance, c.rolloffFactor = l.rolloffFactor) : (o._pos || (o._pos = r._pos || [0, 0, -.5]), e(o))
            }
        return r
    }, Sound.prototype.init = function(e) {
        return function() {
            var n = this,
                t = n._parent;
            n._orientation = t._orientation, n._pos = t._pos, n._velocity = t._velocity, n._pannerAttr = t._pannerAttr, e.call(this), n._pos && t.pos(n._pos[0], n._pos[1], n._pos[2], n._id)
        }
    }(Sound.prototype.init), Sound.prototype.reset = function(e) {
        return function() {
            var n = this,
                t = n._parent;
            return n._orientation = t._orientation, n._pos = t._pos, n._velocity = t._velocity, n._pannerAttr = t._pannerAttr, e.call(this)
        }
    }(Sound.prototype.reset);
    var e = function(e) {
        e._panner = Howler.ctx.createPanner(), e._panner.coneInnerAngle = e._pannerAttr.coneInnerAngle, e._panner.coneOuterAngle = e._pannerAttr.coneOuterAngle, e._panner.coneOuterGain = e._pannerAttr.coneOuterGain, e._panner.distanceModel = e._pannerAttr.distanceModel, e._panner.maxDistance = e._pannerAttr.maxDistance, e._panner.panningModel = e._pannerAttr.panningModel, e._panner.refDistance = e._pannerAttr.refDistance, e._panner.rolloffFactor = e._pannerAttr.rolloffFactor, e._panner.setPosition(e._pos[0], e._pos[1], e._pos[2]), e._panner.setOrientation(e._orientation[0], e._orientation[1], e._orientation[2]), e._panner.setVelocity(e._velocity[0], e._velocity[1], e._velocity[2]), e._panner.connect(e._node), e._paused || e._parent.pause(e._id).play(e._id)
    }
}();